import { render, staticRenderFns } from "./ResortListItem.vue?vue&type=template&id=16317ab3&scoped=true"
import script from "./ResortListItem.vue?vue&type=script&lang=js"
export * from "./ResortListItem.vue?vue&type=script&lang=js"
import style0 from "./ResortListItem.vue?vue&type=style&index=0&id=16317ab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16317ab3",
  null
  
)

export default component.exports